const categories = {
    all: 'Alle',
    MAN_TSHIRT: 'Unisex/Herren T-Shirts',
    MAN_HOODIES: 'Herren Hoodies',
    MAN_SWEATSHIRT: 'Herren Sweatshirts',
    MAN_LONGLEEVES: 'Herren Longleves',
    MAN_TANKTOP: 'Herren Tanktops',
    TROUSERS_UNDERWEAR: 'Hosen & Unterwäsche',
    WOMAN_TSHIRT: 'Damen T-Shirts',
    WOMAN_TANKTOP: 'Damen Tanktops',
    WOMAN_SWEATSHIRT: 'Damen Sweatshirts',
    KINDER_TSHIRT: 'Kinder T-Shirts',
    OTHER: 'Sonstige Produkte',
    MUG: 'Tassen & Gläser',
    HOME: 'Home & Living',
    MAN_TROUSERS_AND_SHORTS: 'Herren Hosen & Shorts',
    MAN_UNDERWEAR: 'Herren Unterwäsche',
    KIDS_TSHIRT: 'Kinder T-Shirts',
    KIDS_HOODIE: 'Kinder Hoodies',
    KIDS_SWEATSHIRT: 'Kinder Sweatshirts',
    KIDS_OTHER: 'Weitere Kinderartikel',
    POSTER_AND_CANVAS: 'Poster & Leinwände',
    GLASS_DISPLAY: 'Glasaufsteller',
    STUFFED_ANIMAL: 'Stofftiere',
    PILLOW: 'Kissen',
    DOOR_MAT: 'Fußmatten',
    ORNAMENT: 'Dekoration',
    HEADWEAR: 'Kopfbekleidungen',
    BAG: 'Taschen',
    SOCKS: 'Socken',
    PHONE_CASE: 'Handyhüllen',
    KEY_CHARM: 'Schlüsselanhänger',
    OTHER_ACCESSORIES: 'Weitere Accessoires',
    BESTSELLER: 'Bestseller',
    NEW: 'Neuheiten',
    SUMMER: 'Sommer',
    OVERSIZED: 'Oversized',
    ORGANIC: 'Organic',
    WINTER: 'Winter',
    MAN_SWIMWEAR: 'Herren Badebekleidung',
    MAN_SPORTSWEAR: 'Herren Sportbekleidung',
    WOMAN_SPORTSWEAR: 'Damen Sportbekleidung',
    FOOTWEAR: 'Schuhe und Schlappen',
    Frauen: 'Frauen',
    'Unisex / Männer': 'Unisex / Männer',
    Sonstiges: 'Sonstiges',
    Kinder: 'Kinder & Babys',
    'Home & Living': 'Home & Living',
    Accessoires: 'Accessoires',
    Bestseller: 'Bestseller',
    Neuheiten: 'Neuheiten',
    'Für den Sommer': 'Sommerkollektion',
    Oversized: 'Oversized',
    Organic: 'Organic',
    Winterkollektion: 'Winterkollektion',
    Eigenmarken: 'By MarketPrint',
    MP_ORIGINALS: 'By MarketPrint',
};

export default categories;
